/* Mome matching sets (Eurus) – used by sections/mome-matching-sets.liquid.
   Step 1: a card per set (print). Tapping it opens one popup with Mom's dress and the matching
   girl dress, each with size buttons, plus "Add girl dress" (no limit).
   Step 2: review with a breakdown, then the whole set goes to the cart with the discount code. */
(function () {
  if (!window.customElements || customElements.get('mome-matching-sets')) return;

  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    var fmt = format || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function delim(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(re);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = delim(cents, 2, ' ', ','); break;
      default: value = delim(cents, 2, ',', '.');
    }
    return fmt.replace(re, value);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function parse(node) {
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }
  var X_ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var PLUS_ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var TICK_ICON = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  class MomeMatchingSets extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this, d = this.dataset;
      this.fmt = d.moneyFormat || '${{amount}}';
      this.discount = parseFloat(d.discount) || 0;
      /* offer: 'set' = discount on Mom + every girl dress; 'kids' = Mom full price, girl dresses discounted */
      this.offer = d.offer === 'kids' ? 'kids' : 'set';
      this.kidsPct = parseFloat(d.kidsDiscount) || 0;
      this.kidsLimit = parseInt(d.kidsLimit, 10) || 0; /* 0 = every girl dress */
      this.t = {};
      Object.keys(d).forEach(function (k) {
        if (k.indexOf('t') === 0 && k.length > 1 && k[1] === k[1].toUpperCase()) self.t[k[1].toLowerCase() + k.slice(2)] = d[k];
      });
      this.step = 1;
      this.chosen = null; /* { set, mom: variant, girls: [variant] } */
      this.draft = null;
      this.added = false;

      /* girl dresses found by print */
      var byPrint = {};
      this.querySelectorAll('script[data-girl-print]').forEach(function (n) {
        var p = parse(n);
        if (p) byPrint[n.getAttribute('data-girl-print')] = p;
      });
      this.templates = {};
      this.querySelectorAll('template[data-qv]').forEach(function (t) {
        if (!self.templates[t.getAttribute('data-qv')]) self.templates[t.getAttribute('data-qv')] = t;
      });
      this.charts = {};
      this.querySelectorAll('template[data-chart]').forEach(function (t) {
        var id = t.getAttribute('data-chart');
        if (!self.charts[id] && t.content.querySelector('img')) self.charts[id] = t;
      });
      /* accessories (optional extras picked in the section) */
      this.accs = [];
      this.querySelectorAll('script[data-acc]').forEach(function (n) { var p = parse(n); if (p && p.variants && p.variants.length) self.accs.push(p); });
      this.accDiscount = d.accDiscount === 'true';
      this.accMatch = d.accMatch !== 'false';
      var designMode = !!(window.Shopify && window.Shopify.designMode);

      this.sets = [];
      this.querySelectorAll('[data-set]').forEach(function (card) {
        var mom = parse(card.querySelector('script[data-mom]'));
        var girl = parse(card.querySelector('script[data-girl-own]')) || byPrint[card.getAttribute('data-print')] || null;
        var ownAccs = [];
        card.querySelectorAll('script[data-set-acc]').forEach(function (n) { var a = parse(n); if (a && a.variants && a.variants.length) ownAccs.push(a); });
        var openBtn = card.querySelector('.mmx-card__media[data-role="open"]');
        var set = {
          id: card.getAttribute('data-set'),
          print: (card.getAttribute('data-print') || '').toLowerCase(),
          accs: ownAccs,
          el: card,
          name: card.getAttribute('data-name') || '',
          img: openBtn ? openBtn.getAttribute('data-img') : '',
          mom: mom,
          girl: girl
        };
        if (!mom) return;
        if (!girl) {
          var dev = card.querySelector('[data-role="dev-note"]');
          if (designMode && dev) dev.hidden = false;
          if (!designMode) { card.hidden = true; return; }
        }
        self.sets.push(set);
        self.paintCard(set);
        card.querySelectorAll('[data-role="open"]').forEach(function (b) {
          b.addEventListener('click', function () { if (set.girl && !set.soldOut) self.openSheet(set, b); });
        });
      });

      /* steps and review */
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('.mbx__tab'));
      this.fill = this.querySelector('[data-role="progress-fill"]');
      this.status = this.querySelector('[data-role="status"]');
      this.grid = this.querySelector('[data-role="grid"]');
      this.review = this.querySelector('[data-role="review"]');
      this.rows = this.querySelector('[data-role="review-rows"]');
      this.addBtn = this.querySelector('[data-role="add-cart"]');
      this.addLabel = this.querySelector('[data-role="add-cart-label"]');
      this.reviewStatus = this.querySelector('[data-role="review-status"]');
      this.stepsWrap = this.querySelector('[data-role="steps"]');

      this.addEventListener('click', function (e) {
        var go = e.target.closest('[data-role="go-step"]');
        if (go && self.contains(go)) { e.preventDefault(); self.setStep(Number(go.dataset.step)); return; }
        if (e.target.closest('[data-role="review-link"]')) { e.preventDefault(); self.setStep(2); return; }
        if (e.target.closest('[data-role="start-over"]')) { e.preventDefault(); self.startOver(); return; }
        if (e.target.closest('[data-role="add-girl"]')) { e.preventDefault(); if (self.chosen) self.openSheet(self.chosen.set, e.target.closest('button'), true); return; }
        var ch = e.target.closest('[data-role="rv-change"]');
        if (ch) { e.preventDefault(); self.openSheet(self.chosen.set, ch); return; }
        var arm = e.target.closest('[data-role="rv-acc-remove"]');
        if (arm) { e.preventDefault(); self.chosen.acc.splice(Number(arm.dataset.i), 1); self.added = false; self.renderReview(); return; }
        var rm = e.target.closest('[data-role="rv-remove"]');
        if (rm) { e.preventDefault(); self.chosen.girls.splice(Number(rm.dataset.i), 1); self.added = false; self.renderReview(); self.paintCard(self.chosen.set); return; }
      });
      if (this.addBtn) this.addBtn.addEventListener('click', function (e) { e.preventDefault(); self.addToCart(); });

      /* popups live at the end of <body> so theme containers can't clip them */
      this.qv = this.querySelector('[data-role="qv"]');
      if (this.qv) {
        this.qvBody = this.qv.querySelector('[data-role="qv-body"]');
        document.body.appendChild(this.qv);
        this.qv.addEventListener('click', function (e) { if (e.target.closest('[data-role="qv-close"]')) self.closeQuickView(); });
      }
      this.chart = this.querySelector('[data-role="chart"]');
      if (this.chart) {
        this.chartBody = this.chart.querySelector('[data-role="chart-body"]');
        document.body.appendChild(this.chart);
        this.chart.addEventListener('click', function (e) { if (e.target.closest('[data-role="chart-close"]')) self.closeChart(); });
      }
      this.buildSheet();
      this._onKey = function (e) {
        if (e.key !== 'Escape') return;
        if (self.chart && !self.chart.hidden) self.closeChart();
        else if (self.qv && !self.qv.hidden) self.closeQuickView();
        else if (self.sheet && !self.sheet.hidden) self.closeSheet();
      };
      document.addEventListener('keydown', this._onKey);
      this.setStep(1, true);
    }
    disconnectedCallback() {
      /* Themes sometimes move sections around the page (that disconnects and reconnects this
         element). Only clean up if the section is really gone, e.g. re-rendered in the editor. */
      var self = this;
      setTimeout(function () {
        if (self.isConnected) return;
        if (self._onKey) document.removeEventListener('keydown', self._onKey);
        if (self.qv && self.qv.parentNode) self.qv.parentNode.removeChild(self.qv);
        if (self.chart && self.chart.parentNode) self.chart.parentNode.removeChild(self.chart);
        if (self.sheet && self.sheet.parentNode) self.sheet.parentNode.removeChild(self.sheet);
        document.documentElement.classList.remove('mbp-lock');
      }, 0);
    }

    /* ---------- helpers ---------- */
    money(c) { return formatMoney(c, this.fmt); }
    sale(c) { return Math.round((Number(c) || 0) * (1 - this.discount / 100)); }
    pct() { return this.offer === 'kids' ? this.kidsPct : this.discount; }
    /* price after the offer for Mom's dress (who 'mom') or girl dress number i (who 'girl', i from 0) */
    itemPay(who, i, c) {
      var n = Number(c) || 0;
      if (this.offer !== 'kids') return this.sale(n);
      if (who === 'mom') return Math.round(n);
      if (this.kidsLimit && i >= this.kidsLimit) return Math.round(n);
      return Math.round(n * (1 - this.kidsPct / 100));
    }
    firstVariant(p) {
      if (!p || !p.variants || !p.variants.length) return null;
      return p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    }
    girlLabel(n) { return (this.t.girlLabel || 'Girl dress [n]').replace('[n]', n); }
    sizesLine(c) {
      var self = this;
      var parts = [(this.t.momShort || 'Mom') + ': ' + (c.mom ? c.mom.size : '–')];
      c.girls.forEach(function (g, i) { parts.push(self.girlLabel(i + 1) + ': ' + (g ? g.size : '–')); });
      return parts.join(' · ');
    }
    totals(c) {
      var full = 0, self = this;
      var add = function (v, p) { var x = v || self.firstVariant(p); if (x) full += Number(x.price) || 0; };
      add(c.mom, c.set.mom);
      c.girls.forEach(function (g) { add(g, c.set.girl); });
      var pay = 0;
      [c.mom].concat(c.girls).forEach(function (v, i) {
        var x = v || self.firstVariant(i === 0 ? c.set.mom : c.set.girl);
        if (x) pay += i === 0 ? self.itemPay('mom', 0, x.price) : self.itemPay('girl', i - 1, x.price);
      });
      (c.acc || []).forEach(function (a) {
        var x = a.v || self.firstVariant(a.p);
        if (!x) return;
        full += Number(x.price) || 0;
        pay += self.accPrice(x.price);
      });
      return { full: full, pay: pay, save: full - pay };
    }
    /* Accessories for this set: same print, or no print in the title */
    accsFor(set) {
      if (set.accs && set.accs.length) return set.accs;
      if (!this.accMatch) return this.accs;
      return this.accs.filter(function (a) { var pr = (a.print || '').toLowerCase().trim(); return !pr || pr === set.print; });
    }
    accPrice(c) { return this.accDiscount && this.offer !== 'kids' ? this.sale(c) : Math.round(Number(c) || 0); }
    hasOptions(p) { return p.variants.length > 1 || (p.variants[0] && p.variants[0].size !== 'One size'); }
    lock(on) { document.documentElement.classList.toggle('mbp-lock', !!on); }

    /* ---------- set cards ---------- */
    paintCard(set) {
      var card = set.el;
      var price = card.querySelector('[data-role="card-price"]');
      var sel = card.querySelector('[data-role="card-sel"]');
      var note = card.querySelector('[data-role="card-note"]');
      var cta = card.querySelector('[data-role="cta-label"]');
      var ctaBtn = card.querySelector('.mmx-card__cta');
      var mv = this.firstVariant(set.mom), gv = this.firstVariant(set.girl);
      set.soldOut = !set.mom.variants.some(function (v) { return v.available; }) || (set.girl && !set.girl.variants.some(function (v) { return v.available; }));
      if (mv) {
        var full = (Number(mv.price) || 0) + (gv ? Number(gv.price) || 0 : 0);
        var pay = this.itemPay('mom', 0, mv.price) + (gv ? this.itemPay('girl', 0, gv.price) : 0);
        if (price) price.innerHTML = '<span>' + esc(this.money(pay)) + '</span>' + (pay < full && !price.hasAttribute('data-no-compare') ? ' <s>' + esc(this.money(full)) + '</s>' : '');
        var forEl = card.querySelector('[data-role="card-for"]');
        if (forEl) { forEl.textContent = this.t.priceFor || ''; forEl.hidden = !this.t.priceFor; }
        var note2 = card.querySelector('[data-role="card-note2"]');
        if (note2) {
          if (!note2.dataset.tpl) note2.dataset.tpl = note2.innerHTML;
          note2.innerHTML = note2.dataset.tpl
            .split('[price]').join(gv ? esc(this.money(this.itemPay('girl', 0, gv.price))) : '')
            .split('[percent]').join(String(this.pct()).replace(/\.0+$/, ''));
        }
      }
      var on = !!(this.chosen && this.chosen.set === set);
      card.classList.toggle('is-picked', on);
      if (sel) { sel.hidden = true; sel.textContent = ''; }
      if (note) { note.hidden = !set.soldOut; note.textContent = set.soldOut ? this.t.soldOut || 'Sold out' : ''; }
      if (cta) cta.textContent = on ? (this.t.changeSizes || 'Change sizes') : (this.t.chooseSizes || 'Choose sizes');
      if (ctaBtn) ctaBtn.disabled = !!set.soldOut || !set.girl;
    }
    paintCards() { var self = this; this.sets.forEach(function (s) { self.paintCard(s); }); }

    /* ---------- steps ---------- */
    setStep(n, quiet) {
      if (n === 2 && !this.chosen) n = 1;
      this.step = n;
      this.dataset.step = n;
      var done = !!this.chosen;
      this.tabs.forEach(function (tab) {
        var k = Number(tab.dataset.step);
        tab.classList.toggle('is-current', k === n);
        tab.classList.toggle('is-done', k === 1 && n === 2);
        if (k === n) tab.setAttribute('aria-current', 'step'); else tab.removeAttribute('aria-current');
        if (k === 2) tab.disabled = !done;
        var num = tab.querySelector('.mbx__tab-num');
        if (num) num.textContent = (k === 1 && n === 2) ? '✓' : String(k);
      });
      var pct = n === 2 ? 100 : (done ? 50 : 0);
      if (this.fill) { this.fill.style.width = pct + '%'; this.fill.parentNode.setAttribute('aria-valuenow', pct); }
      if (this.status) {
        this.status.classList.toggle('is-complete', done);
        if (n === 2) this.status.textContent = this.added ? (this.t.success || '') : (this.t.complete || '');
        else if (done) {
          this.status.innerHTML = esc((this.t.chosen || '[print] set chosen.').replace('[print]', this.chosen.set.name)) +
            ' <button type="button" class="mmx__status-link" data-role="review-link">' + esc(this.t.reviewLink || 'Review your set') + ' ›</button>';
        } else this.status.textContent = this.t.start || '';
      }
      if (this.grid) this.grid.hidden = n !== 1;
      if (this.review) this.review.hidden = n !== 2;
      if (n === 1) this.paintCards(); else this.renderReview();
      if (!quiet && this.stepsWrap) {
        var top = this.stepsWrap.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.6) this.stepsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    startOver() {
      var old = this.chosen;
      this.chosen = null;
      this.added = false;
      if (this.reviewStatus) { this.reviewStatus.textContent = ''; this.reviewStatus.className = 'mbx__status mbx__review-status'; }
      this.setStep(1);
      if (old) this.paintCard(old.set);
    }

    /* ---------- review ---------- */
    renderReview() {
      var c = this.chosen, self = this;
      if (!c || !this.rows) return;
      var row = function (label, product, v, i) {
        var img = product.thumb || product.image || '';
        return '<div class="mbx__rrow">' +
          (img ? '<img class="mbx__rrow-img" src="' + esc(img) + '" alt="" width="84" height="126" loading="lazy">' : '') +
          '<div class="mbx__rrow-info">' +
            '<span class="mbx__rrow-label">' + esc(label) + '</span>' +
            '<span class="mbx__rrow-name">' + esc(product.title) + '</span>' +
            '<span class="mbx__rrow-size">' + esc(self.t.size || 'Size') + ': ' + esc(v.size) + '</span>' +
            '<span class="mbx__rrow-links">' +
              '<button type="button" class="mbx__rv-link" data-role="rv-change">' + esc(self.t.change || 'Change') + '</button>' +
              (i > 0 ? '<button type="button" class="mbx__rv-link" data-role="rv-remove" data-i="' + i + '">' + esc(self.t.remove || 'Remove') + '</button>' : '') +
            '</span>' +
          '</div>' +
          self.rvPrice(v.price, i < 0 ? self.itemPay('mom', 0, v.price) : self.itemPay('girl', i, v.price)) +
        '</div>';
      };
      var html = row(this.t.momLabel || 'For Mom', c.set.mom, c.mom, -1);
      c.girls.forEach(function (g, i) { html += row(self.girlLabel(i + 1), c.set.girl, g, i); });
      (c.acc || []).forEach(function (a, i) {
        var img = a.p.thumb || a.p.image || '';
        html += '<div class="mbx__rrow">' +
          (img ? '<img class="mbx__rrow-img" src="' + esc(img) + '" alt="" width="84" height="126" loading="lazy">' : '') +
          '<div class="mbx__rrow-info">' +
            '<span class="mbx__rrow-label">' + esc(self.t.accLabel || 'Accessory') + '</span>' +
            '<span class="mbx__rrow-name">' + esc(a.p.title) + '</span>' +
            (self.hasOptions(a.p) ? '<span class="mbx__rrow-size">' + esc(a.v.size) + '</span>' : '') +
            '<span class="mbx__rrow-links">' +
              (self.hasOptions(a.p) ? '<button type="button" class="mbx__rv-link" data-role="rv-change">' + esc(self.t.change || 'Change') + '</button>' : '') +
              '<button type="button" class="mbx__rv-link" data-role="rv-acc-remove" data-i="' + i + '">' + esc(self.t.remove || 'Remove') + '</button>' +
            '</span>' +
          '</div>' +
          self.rvPrice(a.v.price, self.accPrice(a.v.price)) +
        '</div>';
      });
      this.rows.innerHTML = html;
      var t = this.totals(c);
      var q = function (r) { return self.review.querySelector('[data-role="' + r + '"]'); };
      if (q('rv-original')) q('rv-original').textContent = this.money(t.full);
      if (q('rv-savings')) q('rv-savings').textContent = '−' + this.money(t.save);
      var dl = q('rv-discounts');
      if (dl) {
        var items = [], tpl = this.t.itemDiscount || '[item] · [percent]% off';
        var push = function (label, price, pay, pc) {
          var full = Math.round(Number(price) || 0);
          if (pay < full) items.push('<div class="mbx__line is-item"><span>' + esc(tpl.replace('[item]', label).replace('[percent]', String(pc).replace(/\.0+$/, ''))) + '</span><span>−' + esc(self.money(full - pay)) + '</span></div>');
        };
        push(this.t.momLabel || 'For Mom', c.mom.price, this.itemPay('mom', 0, c.mom.price), this.pct());
        c.girls.forEach(function (g, i) { push(self.girlLabel(i + 1), g.price, self.itemPay('girl', i, g.price), self.pct()); });
        (c.acc || []).forEach(function (a) { push(a.p.title, a.v.price, self.accPrice(a.v.price), self.discount); });
        dl.innerHTML = items.join('');
        dl.hidden = !items.length;
      }
      if (q('rv-total')) q('rv-total').textContent = this.money(t.pay);
      if (this.addLabel && !this._busy) {
        var lbl = this.t.button || 'Add set to cart';
        this.addLabel.textContent = this.t.buttonPrice === 'true' ? lbl + ' · ' + this.money(t.pay) : lbl;
      }
    }

    /* review row price: sale price, full price crossed out and an "x% off" tag when discounted */
    rvPrice(price, pay) {
      var full = Math.round(Number(price) || 0);
      if (!(pay < full)) return '<span class="mbx__rrow-price">' + esc(this.money(full)) + '</span>';
      var pc = Math.round((1 - pay / full) * 100);
      var tag = this.t.offTag || '[percent]% off';
      return '<span class="mbx__rrow-price mmx-rv-price"><span>' + esc(this.money(pay)) + '</span><s>' + esc(this.money(full)) + '</s>' +
        (tag ? '<em class="mmx-rv-tag">' + esc(tag.replace('[percent]', pc)) + '</em>' : '') + '</span>';
    }

    /* ---------- size popup ---------- */
    buildSheet() {
      var self = this;
      var sh = document.createElement('div');
      sh.className = 'mbx mmx-sheet' + (this.classList.contains('is-rounded') ? ' is-rounded' : '');
      sh.hidden = true;
      sh.setAttribute('data-lenis-prevent', '');
      var accent = this.style.getPropertyValue('--mbx-accent') || getComputedStyle(this).getPropertyValue('--mbx-accent');
      if (accent) sh.style.setProperty('--mbx-accent', accent.trim());
      sh.innerHTML =
        '<div class="mmx-sheet__backdrop" data-x></div>' +
        '<div class="mmx-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="MmxTitle-' + esc(this.dataset.section) + '">' +
          '<div class="mmx-sheet__photo"><img alt="" data-photo></div>' +
          '<div class="mmx-sheet__main" data-main></div>' +
        '</div>';
      document.body.appendChild(sh);
      this.sheet = sh;
      this.sheetMain = sh.querySelector('[data-main]');
      sh.addEventListener('click', function (e) {
        if (e.target.closest('[data-x]')) { self.closeSheet(); return; }
        var chip = e.target.closest('.mmx-chip');
        if (chip && !chip.disabled) {
          var who = chip.dataset.who, i = Number(chip.dataset.i);
          var p = who === 'mom' ? self.draft.set.mom : (who === 'acc' ? self.draft.acc[i].p : self.draft.set.girl);
          var v = p.variants.filter(function (x) { return String(x.id) === chip.dataset.v; })[0];
          if (who === 'mom') self.draft.mom = v; else if (who === 'acc') self.draft.acc[i].v = v; else self.draft.girls[i] = v;
          self.renderSheet(true);
          return;
        }
        if (e.target.closest('[data-add]')) {
          self.draft.girls.push(null);
          self.renderSheet(true);
          var body = self.sheetMain.querySelector('.mmx-sheet__body');
          if (body) body.scrollTo({ top: body.scrollHeight, behavior: 'smooth' });
          return;
        }
        var aadd = e.target.closest('[data-acc-add]');
        if (aadd) {
          var ap = self.accsFor(self.draft.set).filter(function (x) { return String(x.id) === aadd.dataset.accAdd; })[0];
          if (ap) {
            var only = !self.hasOptions(ap) ? (ap.variants.filter(function (x) { return x.available; })[0] || null) : null;
            self.draft.acc.push({ p: ap, v: only });
            self.renderSheet(true);
            var ar = self.sheetMain.querySelector('[data-row="acc' + (self.draft.acc.length - 1) + '"]');
            if (ar) ar.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
          return;
        }
        var arm2 = e.target.closest('[data-acc-rm]');
        if (arm2) { self.draft.acc.splice(Number(arm2.dataset.accRm), 1); self.renderSheet(true); return; }
        var rm = e.target.closest('[data-rm]');
        if (rm) { self.draft.girls.splice(Number(rm.dataset.rm), 1); self.renderSheet(true); return; }
        var sc = e.target.closest('[data-chart]');
        if (sc) { e.preventDefault(); e.stopPropagation(); self.openChart(sc.dataset.chart, sc); return; }
        var det = e.target.closest('[data-qv]');
        if (det) { e.preventDefault(); e.stopPropagation(); self.openQuickView(det.dataset.qv, false, det); return; }
        if (e.target.closest('[data-go]')) self.confirmSheet();
      });
    }
    openSheet(set, opener, addGirl) {
      var c = this.chosen;
      if (c && c.set === set) this.draft = { set: set, mom: c.mom, girls: c.girls.slice(), acc: (c.acc || []).map(function (a) { return { p: a.p, v: a.v }; }) };
      else this.draft = { set: set, mom: null, girls: [null], acc: [] };
      if (addGirl) this.draft.girls.push(null);
      this.sheetOpener = opener || null;
      var img = this.sheet.querySelector('[data-photo]');
      var src = set.img || set.mom.image || '';
      img.src = src;
      img.alt = set.name;
      this.sheet.querySelector('.mmx-sheet__photo').hidden = !src;
      this.renderSheet();
      this.sheet.hidden = false;
      this.lock(true);
      var self = this;
      requestAnimationFrame(function () {
        self.sheet.classList.add('is-open');
        var body = self.sheetMain.querySelector('.mmx-sheet__body');
        if (addGirl && body) body.scrollTop = body.scrollHeight;
        var x = self.sheet.querySelector('.mmx-sheet__close');
        if (x) x.focus({ preventScroll: true });
      });
    }
    closeSheet() {
      if (!this.sheet || this.sheet.hidden) return;
      var sh = this.sheet;
      sh.classList.remove('is-open');
      this.lock(false);
      setTimeout(function () { if (!sh.classList.contains('is-open')) sh.hidden = true; }, 220);
      if (this.sheetOpener && this.sheetOpener.isConnected) this.sheetOpener.focus({ preventScroll: true });
    }
    missing() {
      var d = this.draft;
      if (!d.mom) return { text: this.t.chooseMom || "Choose Mom's size", key: 'mom' };
      for (var i = 0; i < d.girls.length; i++) {
        if (!d.girls[i]) return { text: (this.t.chooseGirl || 'Choose size for [dress]').replace('[dress]', this.girlLabel(i + 1)), key: 'girl' + i };
      }
      for (var k = 0; k < (d.acc || []).length; k++) {
        if (!d.acc[k].v) return { text: (this.t.chooseAcc || 'Choose an option for [item]').replace('[item]', d.acc[k].p.title), key: 'acc' + k };
      }
      return null;
    }
    renderSheet(keepScroll) {
      var d = this.draft, set = d.set, self = this, t = this.t;
      var body0 = this.sheetMain.querySelector('.mmx-sheet__body');
      var y = keepScroll && body0 ? body0.scrollTop : 0;
      var chips = function (who, i, p, cur) {
        return '<div class="mmx-chips" role="group" aria-label="' + esc(t.size || 'Size') + '">' + p.variants.map(function (v) {
          var on = cur && String(cur.id) === String(v.id);
          return '<button type="button" class="mmx-chip" data-who="' + who + '" data-i="' + i + '" data-v="' + v.id + '" aria-pressed="' + on + '"' +
            (v.available ? '' : ' disabled title="' + esc(t.soldOut || 'Sold out') + '"') + '>' + esc(v.size) + '</button>';
        }).join('') + '</div>';
      };
      var row = function (who, i, label, p, cur) {
        var v = cur || self.firstVariant(p);
        var pp = v ? self.itemPay(who, i, v.price) : 0;
        var price = v ? '<small>' + esc(self.money(pp)) + (pp < Math.round(Number(v.price) || 0) ? ' <s>' + esc(self.money(v.price)) + '</s>' : '') + '</small>' : '';
        return '<div class="mmx-row" data-row="' + who + (who === 'girl' ? i : '') + '">' +
          '<div class="mmx-row__img">' + (p.thumb ? '<img src="' + esc(p.thumb) + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="mmx-row__top"><span class="mmx-row__label">' + esc(label) + '</span>' +
            (who === 'girl' && i > 0 ? '<button type="button" class="mmx-row__rm" data-rm="' + i + '">' + esc(t.remove || 'Remove') + '</button>' : '') + '</div>' +
          '<p class="mmx-row__title">' + esc(p.title) + ' ' + price + '</p>' +
          '<div class="mmx-row__sizes">' +
            '<div class="mmx-row__links"><button type="button" class="mmx-row__link" data-qv="' + p.id + '" data-url="' + esc(p.url) + '">' + esc(t.details || 'Details') + '</button>' +
              (self.charts[p.id] ? '<button type="button" class="mmx-row__link" data-chart="' + p.id + '">' + esc(t.sizeChart || 'Size chart') + '</button>' : '') +
            '</div>' +
            chips(who, i, p, cur) +

          '</div>' +
        '</div>';
      };
      var miss = this.missing();
      var tot = this.totals(d);
      var sid = esc(this.dataset.section);
      this.sheetMain.innerHTML =
        '<div class="mmx-sheet__head">' +
          '<div><h2 class="mmx-sheet__title h4" id="MmxTitle-' + sid + '">' + esc(set.name) + '</h2>' +
          (t.sheetSub ? '<p class="mmx-sheet__sub">' + esc(t.sheetSub) + '</p>' : '') + '</div>' +
          '<button type="button" class="mmx-sheet__close" data-x aria-label="' + esc(t.close || 'Close') + '">' + X_ICON + '</button>' +
        '</div>' +
        '<div class="mmx-sheet__body" data-lenis-prevent>' +
          row('mom', 0, t.momLabel || 'For Mom', set.mom, d.mom) +
          d.girls.map(function (g, i) { return row('girl', i, self.girlLabel(i + 1), set.girl, g); }).join('') +
          '<button type="button" class="mmx-sheet__add" data-add>' + PLUS_ICON + '<span>' + esc(t.addGirl || 'Add girl dress') + '</span>' +
            '</button>' +
          (d.acc || []).map(function (a, i) {
            var v = a.v || self.firstVariant(a.p);
            var pr = v ? '<small>' + esc(self.money(self.accPrice(v.price))) + (self.accPrice(v.price) < Math.round(Number(v.price) || 0) ? ' <s>' + esc(self.money(v.price)) + '</s>' : '') + '</small>' : '';
            return '<div class="mmx-row is-acc" data-row="acc' + i + '">' +
              '<div class="mmx-row__img">' + (a.p.thumb ? '<img src="' + esc(a.p.thumb) + '" alt="" loading="lazy">' : '') + '</div>' +
              '<div class="mmx-row__top"><span class="mmx-row__label">' + esc(t.accLabel || 'Accessory') + '</span>' +
                '<button type="button" class="mmx-row__rm" data-acc-rm="' + i + '">' + esc(t.remove || 'Remove') + '</button></div>' +
              '<p class="mmx-row__title">' + esc(a.p.title) + ' ' + pr + '</p>' +
              '<div class="mmx-row__sizes">' +
                (self.templates[a.p.id] ? '<div class="mmx-row__links"><button type="button" class="mmx-row__link" data-qv="' + a.p.id + '" data-url="' + esc(a.p.url) + '">' + esc(t.details || 'Details') + '</button></div>' : '') +
                (self.hasOptions(a.p) ? chips('acc', i, a.p, a.v) : '') +
              '</div>' +
            '</div>';
          }).join('') +
          (this.accsFor(set).length ? '<div class="mmx-acc"><p class="mmx-acc__title">' + esc(t.accTitle || 'Add an accessory') + (t.accNote ? ' <small>' + esc(t.accNote) + '</small>' : '') + '</p>' +
            '<div class="mmx-acc__list">' + this.accsFor(set).map(function (ap) {
              var v0 = self.firstVariant(ap), sold = !ap.variants.some(function (x) { return x.available; });
              return '<div class="mmx-acc__item">' +
                '<span class="mmx-acc__img">' + (ap.thumb ? '<img src="' + esc(ap.thumb) + '" alt="" loading="lazy">' : '') + '</span>' +
                '<span class="mmx-acc__name">' + esc(ap.title) + '</span>' +
                '<span class="mmx-acc__price">' + (v0 ? esc(self.money(self.accPrice(v0.price))) + (self.accPrice(v0.price) < Math.round(Number(v0.price) || 0) ? ' <s>' + esc(self.money(v0.price)) + '</s>' : '') : '') + '</span>' +
                '<button type="button" class="mmx-acc__add" data-acc-add="' + ap.id + '"' + (sold ? ' disabled' : '') + '>' + (sold ? esc(t.soldOut || 'Sold out') : PLUS_ICON + '<span>' + esc(t.accAdd || 'Add') + '</span>') + '</button>' +
              '</div>';
            }).join('') + '</div></div>' : '') +
        '</div>' +
        '<div class="mmx-sheet__foot">' +
          '<div class="mmx-sheet__sum"><span>' + esc((t.sheetTotal || 'Total for [count] dresses').replace('[count]', 1 + d.girls.length) + ((d.acc || []).length ? ' ' + (t.accCount || '+ [n] accessories').replace('[n]', d.acc.length) : '')) + '</span><span><b>' + esc(this.money(tot.pay)) + '</b>' +
            (tot.save > 0 ? ' <s>' + esc(this.money(tot.full)) + '</s> · <span class="mmx-sheet__save">' + esc((t.save || 'You save [amount]').replace('[amount]', this.money(tot.save))) + '</span>' : '') + '</span></div>' +
          '<button type="button" class="button button-solid not-icon leading-normal w-full pr-5 pl-5 pt-3 pb-3 mmx-sheet__go' + (miss ? ' is-waiting' : '') + '" data-go>' +
            '<span class="flex items-center justify-center">' + esc(miss ? miss.text : (t.continue || 'Continue to review')) + '</span></button>' +
        '</div>';
      if (keepScroll) { var b = this.sheetMain.querySelector('.mmx-sheet__body'); if (b) b.scrollTop = y; }
    }
    confirmSheet() {
      var miss = this.missing();
      if (miss) {
        var r = this.sheetMain.querySelector('[data-row="' + miss.key + '"]');
        if (r) {
          r.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          r.classList.remove('is-needed'); void r.offsetWidth; r.classList.add('is-needed');
        }
        return;
      }
      var prev = this.chosen;
      this.chosen = { set: this.draft.set, mom: this.draft.mom, girls: this.draft.girls.slice(), acc: (this.draft.acc || []).slice() };
      this.added = false;
      if (this.reviewStatus) { this.reviewStatus.textContent = ''; this.reviewStatus.className = 'mbx__status mbx__review-status'; }
      this.sheetOpener = null;
      this.closeSheet();
      if (prev && prev.set !== this.chosen.set) this.paintCard(prev.set);
      this.paintCard(this.chosen.set);
      if (this.dataset.autoReview !== 'false') this.setStep(2);
      else this.setStep(1);
    }

    /* ---------- quick view (Details) ---------- */
    openQuickView(pid, sizeChart, opener) {
      var tpl = this.templates[pid] || document.querySelector('template[data-qv="' + pid + '"]');
      if (!this.qv) this.qv = document.querySelector('.mmx-qv[data-section="' + this.dataset.section + '"]');
      if (!this.qv || !tpl) {
        /* No quick view content: open the product page instead */
        var url = opener && opener.dataset ? opener.dataset.url : '';
        if (url) { var w = window.open(url, '_blank'); if (!w) window.location.href = url; }
        return;
      }
      if (!this.qvBody) this.qvBody = this.qv.querySelector('[data-role="qv-body"]');
      if (this.qv.parentNode !== document.body) document.body.appendChild(this.qv);
      this.qvOpener = opener || null;
      this.qvBody.innerHTML = '';
      this.qvBody.appendChild(tpl.content.cloneNode(true));
      this.setupQvGallery(this.qvBody);
      this.qv.hidden = false;
      this.lock(true);
      var self = this;
      requestAnimationFrame(function () {
        self.qv.classList.add('is-open');
        if (sizeChart) {
          var row = self.qvBody.querySelector('[data-qv-size]');
          if (row) {
            var head = row.querySelector('.mbq__row-head'), body = row.querySelector('.mbq__row-body');
            if (head) head.setAttribute('aria-expanded', 'true');
            if (body) body.hidden = false;
            setTimeout(function () { row.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 60);
          }
        }
        var c = self.qv.querySelector('.mbq__close');
        if (c) c.focus({ preventScroll: true });
      });
    }
    openChart(pid, opener) {
      var tpl = this.charts[pid];
      if (!this.chart || !tpl) return;
      if (this.chart.parentNode !== document.body) document.body.appendChild(this.chart);
      this.chartOpener = opener || null;
      this.chartBody.innerHTML = '';
      this.chartBody.appendChild(tpl.content.cloneNode(true));
      this.chartBody.scrollTop = 0;
      this.chart.hidden = false;
      this.lock(true);
      var self = this;
      requestAnimationFrame(function () {
        self.chart.classList.add('is-open');
        var c = self.chart.querySelector('.mmx-chart__close');
        if (c) c.focus({ preventScroll: true });
      });
    }
    closeChart() {
      if (!this.chart || this.chart.hidden) return;
      this.chart.classList.remove('is-open');
      this.chart.hidden = true;
      this.chartBody.innerHTML = '';
      if (!this.sheet || this.sheet.hidden) this.lock(false);
      if (this.chartOpener && this.chartOpener.isConnected) this.chartOpener.focus({ preventScroll: true });
    }
    closeQuickView() {
      if (!this.qv || this.qv.hidden) return;
      this.qv.classList.remove('is-open');
      this.qv.hidden = true;
      this.qvBody.innerHTML = '';
      if (!this.sheet || this.sheet.hidden) this.lock(false);
      if (this.qvOpener && this.qvOpener.isConnected) this.qvOpener.focus({ preventScroll: true });
    }
    setupQvGallery(root) {
      var track = root.querySelector('[data-qv-track]');
      if (!track) return;
      var thumbs = root.querySelectorAll('[data-qv-thumb]');
      var count = track.children.length;
      var go = function (i) { i = Math.max(0, Math.min(count - 1, i)); track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); };
      var current = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
      root.querySelectorAll('[data-qv-step]').forEach(function (b) { b.addEventListener('click', function () { go(current() + Number(b.dataset.qvStep)); }); });
      thumbs.forEach(function (b) { b.addEventListener('click', function () { go(Number(b.dataset.qvThumb)); }); });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = current();
          thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
        }, 80);
      }, { passive: true });
    }

    /* ---------- cart ---------- */
    cartStore() {
      try { return window.Alpine && window.Alpine.store ? window.Alpine.store('xMiniCart') : null; }
      catch (e) { return null; }
    }
    async openEurusDrawer() {
      var store = this.cartStore();
      if (!store || typeof store.openCart !== 'function') return false;
      try { store.needReload = true; } catch (e) {}
      if (typeof store.reLoad === 'function') { try { await store.reLoad(); } catch (e) {} }
      store.openCart();
      return true;
    }
    /* Adds the section's discount code (e.g. MOMMYME25) to the cart, keeping codes already there.
       If Shopify says the code isn't valid for this cart, the discount link is used as well,
       which saves the code for checkout. Shopify still checks the code's own rules. */
    async applyDiscountCode(root) {
      var code = (this.dataset.discountCode || '').trim();
      if (!code) return;
      var low = code.toLowerCase();
      var ok = false;
      try {
        var codes = [code];
        try {
          var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
          (cart.discount_codes || []).forEach(function (d) {
            if (d && d.code && codes.every(function (c) { return c.toLowerCase() !== d.code.toLowerCase(); })) codes.push(d.code);
          });
        } catch (e) {}
        var res = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
        if (res.ok) {
          var after = await res.json();
          ok = (after.discount_codes || []).some(function (d) { return d && d.code && d.code.toLowerCase() === low && d.applicable !== false; });
          if (!ok && window.console) console.warn('[Mome matching sets] Shopify did not apply discount code "' + code + '". Check it exists in Shopify admin > Discounts and applies to these dresses.', after.discount_codes);
        }
      } catch (err) {}
      if (!ok) {
        try { await fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' }); } catch (e) {}
      }
    }
    async addToCart() {
      var c = this.chosen;
      if (!c || this._busy) return;
      var self = this, t = this.t;
      var bundleId = 'MM' + Date.now().toString(36).toUpperCase();
      var name = this.dataset.bundleName || 'Mommy & Me Set';
      var label = this.dataset.propertyLabel || 'Bundle';
      var items = [c.mom].concat(c.girls).concat((c.acc || []).map(function (a) { return a.v; })).map(function (v) {
        var props = { _bundle: name, _bundle_id: bundleId };
        if (self.dataset.showProperty === 'true') props[label] = name;
        return { id: Number(v.id), quantity: 1, properties: props };
      });
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this._busy = true;
      this.addBtn.disabled = true;
      this.addBtn.classList.add('is-loading');
      if (this.addLabel && t.adding) this.addLabel.textContent = t.adding;
      this.reviewStatus.textContent = '';
      this.reviewStatus.className = 'mbx__status mbx__review-status';
      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message || t.error);
        await this.applyDiscountCode(root);
        document.dispatchEvent(new CustomEvent('mome:bundle-added', { detail: { bundleId: bundleId, items: items } }));
        this.added = true;
        var after = this.dataset.afterAdd || 'drawer';
        if (after === 'cart' || (after === 'drawer' && !(await this.openEurusDrawer()))) {
          window.location.href = root + 'cart';
          return;
        }
        var reset = this.dataset.resetAfter || 'step1';
        if (reset === 'reload') { window.location.reload(); return; }
        if (reset === 'step1') {
          /* fresh start: back to step 1 with nothing picked */
          this.startOver();
          if (this.status) this.status.textContent = t.success || '';
          return;
        }
        this.reviewStatus.innerHTML = esc(t.success || '') + ' <a href="' + esc(root) + 'cart">' + esc(t.viewCart || 'View cart') + '</a>';
        this.reviewStatus.classList.add('is-success');
        if (this.status) this.status.textContent = t.success || '';
      } catch (err) {
        this.reviewStatus.textContent = (err && err.message) || t.error || 'Error';
        this.reviewStatus.classList.add('is-error');
      } finally {
        this._busy = false;
        this.addBtn.disabled = false;
        this.addBtn.classList.remove('is-loading');
        this.renderReview();
      }
    }
  }

  customElements.define('mome-matching-sets', MomeMatchingSets);
})();